import React from 'react'
import doubts from "../images/doubts.png";
import laptop from "../images/laptop.png";
import consult from "../images/consult.png";
import doctorImg from "../images/headerImg.png";

const CALENDLY_ONLINE_URL = "https://calendly.com/slimming-doctor/online_consultation_10";
const CALENDLY_INPERSON_URL = "https://calendly.com/slimming-doctor/in-person";

const Bookappointment = () => {
  return (
    <>
      <section className="bg-white py-20 font-poppins">
        <img
          src={doubts}
          alt="dots"
          className="absolute left-0 top-[75px] w-16 sm:w-20 opacity-80 pointer-events-none select-none"
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 font-poppins">
          <div className="text-center mb-12 font-poppins">
            <h1 className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[50px]">
              Book Your Free Consultation
            </h1>
            <p className="mt-4 text-[16px] text-[#556987] max-w-2xl mx-auto leading-relaxed">
              You can choose to have a consultation either at our clinic in Harrow,
              or online from the comfort of your home – the choice is yours.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto font-poppins">

            <button
              onClick={() => window.open(CALENDLY_ONLINE_URL, '_blank', 'noopener,noreferrer')}
              className="bg-white rounded border border-slate-200 shadow-sm px-10 py-10 flex flex-col items-center hover:border-[#35C3D9] hover:shadow-md transition-all duration-200 cursor-pointer text-left w-full"
            >
              <img
                src={laptop}
                alt="Online consultation"
                className="w-32 h-32 object-contain mb-6"
              />
              <h3 className="text-[24px] font-semibold text-[#000000]">
                Online consultation
              </h3>
              <span className="mt-4 text-[14px] font-medium text-[#35C3D9]">Book Now →</span>
            </button>

            <button
              onClick={() => window.open(CALENDLY_INPERSON_URL, '_blank', 'noopener,noreferrer')}
              className="bg-white rounded border border-slate-200 shadow-sm px-10 py-10 flex flex-col items-center hover:border-[#35C3D9] hover:shadow-md transition-all duration-200 cursor-pointer text-left w-full"
            >
              <img
                src={consult}
                alt="In-person consultation"
                className="w-32 h-32 object-contain mb-6"
              />
              <h3 className="text-[24px] font-semibold text-[#000000]">
                In-person consultation
              </h3>
              <span className="mt-4 text-[14px] font-medium text-[#35C3D9]">Book Now →</span>
            </button>
          </div>
        </div>
      </section>

      {/* ==============Section2================ */}

      <section className="bg-[#FAFAFA] py-20 font-poppins">
        <div className=" relative max-w-7xl mx-auto px-2 sm:px-2 font-poppins">

          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">

            <div >
              <h2 className="text-[#2A3342] text-[48px] font-bold mb-6">
                Hi, My name is Dr. Aasim
              </h2>

              <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                Hi, My name is Dr. Aasim, and I am a Weight Loss Specialist Doctor.
              </p>

              <p className="text-[#556987] leading-relaxed mb-4">
                My team and I are here to support you on your health journey.
              </p>

              <p className="text-[#556987] leading-relaxed mb-4">
                Please complete the brief assessment to book a free consultation with myself.
              </p>

              <p className="text-[#556987] leading-relaxed">
                This information will enable me to better understand your health
                history and needs to provide you with the best treatment plan during our consultation.
              </p>
            </div>

            <div className="flex justify-center">
              <img
                src={doctorImg}
                alt="Doctor"
                className="w-full rounded-2xl object-cover"
              />
            </div>

          </div>
        </div>
      </section>

    </>
  )
}

export default Bookappointment